'use strict';

// TODO: remove from `core-js@4`
require('../../modules/esnext.string.match-all');
var parent = require('../../actual/instance/match-all');
module.exports = parent;